const Product = () =>
  import('@/views/main/live/product/Product.vue')
export default {
  path: '/main/live/product',
  name: 'Product',
  component: Product
}
